'use strict';

/*--------------------------------------------------------------------------*
* MV
*--------------------------------------------------------------------------*/
$('.slide').slick({
  speed: 2000,
  autoplay: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        dots:true,
      }
    }
  ]
});